import type { DescopeProject } from "@/lib/auth/token-manager";

/**
 * The customer Descope project this bundle signs in against, and the host it is
 * served from. Both are inlined at build time: the host comes from
 * `config.region.descopeBaseUrl` (task 327), so the session layer, the Descope
 * SDK and the page's CSP `connect-src` all name the same one.
 */
export const DESCOPE_PROJECT: DescopeProject = {
  projectId: import.meta.env.VITE_DESCOPE_PROJECT_ID as string,
  baseUrl: import.meta.env.VITE_DESCOPE_BASE_URL as string,
};
